import { IAdapterData } from "@/entities";
import { BACKEND_BASE_URL, IResponseError } from "@/services";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";
import { IAdapterService } from "./adapter.types";

export class AdapterService implements IAdapterService {
  async getAssignableAdapters(): Promise<IAdapterData[] | undefined> {
    const { response, error } = await handleResponse<IAdapterData[], IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/adapter/assignable`)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
}
